import React, { useState, useEffect } from "react";

import { Link } from "react-router-dom";
import { Alert } from "reactstrap";

import ProfileMenu from "../../Components/CommonForBoth/TopBarDropDown/ProfileMenu";

import logo from "../../assets/images/logo.svg";
import logoLight from "../../assets/images/whitelogo.png";
import logoLightSvg from "../../assets/images/logo-light.svg";
import logoDark from "../../assets/images/logo-dark.png";

import { withTranslation } from "react-i18next";
import NotificationDropDown from "../../Components/CommonForBoth/NotificationDropDown";
import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "reselect";
import { fetchCustomerProfile } from "../../slices/customerProfile/thunk";



const Header = (props: any) => {
  const dispatch = useDispatch<any>();

  const selectCustomerProfile = createSelector(
    (state: any) => state.CustomerProfile,
    (cp) => ({ cstpack: cp.cstpack })
  );
  const { cstpack: cstpacck } = useSelector(selectCustomerProfile);

  const userRole = localStorage.getItem('userole_');

  const [alertMsgg, setAlertMsgg] = useState<any>({open:false, type:"success", content:'Messages here.', time:'2500'});
  const handleAlertMsggClose = ( event?: React.SyntheticEvent | Event, reason?: string) => {  
      if (reason === "clickaway") { return; } 
      setAlertMsgg({ ...alertMsgg, open: false }) 
  };

  const [cartLength, setCartLength] = useState(0);

  useEffect(() => {
    if (localStorage.getItem('userole_') === "cst") {
      dispatch(fetchCustomerProfile());
    }
  }, [dispatch]);

  useEffect(() => {
    setCartLength(parseInt(localStorage.getItem("cart_length") || "0"));
    const updateCartLength = () => {
      const length = localStorage.getItem("cart_length");
      setCartLength(parseInt(length || "0"));
    };
    updateCartLength();
    window.addEventListener("cartLengthUpdated", updateCartLength);
    window.addEventListener("focus", updateCartLength);
    return () => {
      window.removeEventListener("cartLengthUpdated", updateCartLength);
      window.removeEventListener("focus", updateCartLength);
    };
  }, []);

  

  return (
    <React.Fragment>
      {alertMsgg.open && (
          <Alert 
              color={alertMsgg.type === "success" ? "success" : "danger"} 
              toggle={handleAlertMsggClose}
              style={{ fontWeight: "bold" }}
          >
              {alertMsgg.content}
          </Alert>
      )}
      
      <header id="page-topbar">
        <div className="navbar-header">
          <div className="d-flex">
            <div className="navbar-brand-box">
              <Link to="/" className="logo logo-dark">
                <span className="logo-sm">
                  <img src={logo} alt=""  style={{maxHeight: "22px"}} />
                </span>
                <span className="logo-lg">
                  <img src={logoDark} alt=""  style={{maxHeight: "17px"}} />
                </span>
              </Link>

              <Link to="/" className="logo logo-light">
                <span className="logo-sm">
                  <img src={logoLightSvg} alt="" style={{maxHeight: "22px"}} />
                </span>
                <span className="logo-lg">
                  <img src={logoLight} alt="" style={{maxHeight: "55px"}} />
                </span>
              </Link>
            </div>

            {/* <button
              type="button"
              className="btn btn-sm px-3 font-size-16 d-lg-none header-item"
              data-toggle="collapse"
              onClick={props.toggleLeftmenu}
              data-target="#topnav-menu-content"
            >
              <i className="fa fa-fw fa-bars" />
            </button> */}
    </div>

          <div className="d-flex gap-3 align-items-center">

            {/* FREE_PLATFORM_MODE: Subscribe button hidden. To restore: uncomment and re-enable fetch_experts + subscription modal */}

            {userRole === "cst" && (
              <Link to="/cbookinggroup" className="">
                <button className="btn header-item noti-icon position-relative font-size-14">
                  <i className="bx bx-cart"></i>
                  {cartLength > 0 && (
                    <span className="badge bg-danger rounded-pill">{cartLength}</span>
                  )}
                </button>
              </Link>
            )}

            <NotificationDropDown />

            <ProfileMenu />
          </div>
        </div>
      </header>
    </React.Fragment>
  );
};

export default (withTranslation()(Header));
